import React from "react";
import ButtonComp from "themes/elements/Button";

function DeleteModalFooter(props) {
  const { setDlt, handleNewsDelete, formData, isLoading } = props;

  return (
    <div className="flex align-center justify-end gap-3">
      <ButtonComp onClick={() => setDlt(false)} variant="secondary">
        Cancel
      </ButtonComp>
      <ButtonComp
        variant="danger"
        loading={isLoading}
        onClick={() => handleNewsDelete(formData?.id)}
      >
        Delete
      </ButtonComp>
    </div>
  );
}

export default DeleteModalFooter;
